<template>
  <!-- 通过key实现tab切换实现组件更新，否则就要实现各种tab下的数据切换 -->
  <pay-order-item :key="[tabIndex, pageType].join('')" :type="tabIndex" :pageType="pageType" @tab="onTab"
    @pageTypeChange="onPageTypeChange"></pay-order-item>
</template>

<script>
/** 应收账单 */
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import payOrderItem from './children/pay_order_item.vue';

export default {
  name: 'payOrder',
  mixins: [tableFilterValueMixins],
  components: {
    payOrderItem,
  },
  data() {
    return {
      // 1 - 待收款，2 - 已收款
      tabIndex: '1',
      // 1-应付总部  2-应付售后
      pageType: '0',
    };
  },
  mounted: function () { },
  methods: {
    onTab(value) {
      this.tabIndex = value;
    },
    onPageTypeChange(value) {
      this.pageType = value;
    },
  },
};
</script>

<style lang="scss"></style>
